import { gql } from "@apollo/client";

export const UPDATE_CLASS_MUTATION = gql`
  mutation updateClass($input: UpdateClassInput!) {
    updateClass(input: $input) {
      class {
        id
      }
      errors {
        __typename
        ... on NotQuiteSureProblem {
          message
        }
        ... on ConflictProblem {
          message
        }
        ... on Problem {
          message
        }
      }
    }
  }
`;
